import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { MessageService } from '@shared/services/message.service';
import { QuestionnaireService } from '@app/shared/services/questionnaire.service';
import { environment } from '@environment/environment';

@Component({
  selector: 'db-formly-field-input',
  templateUrl: './custom-field-input.component.html',
  styleUrls: ['./custom-field-input.component.scss']
})
export class CustomFieldInputComponent extends FieldType implements OnInit {

  constructor(
    private messageService: MessageService,
    private service: QuestionnaireService
  ) {
    super();
  }

  ngOnInit() {
  }

  editField(f) {
    // send message to subscribers via observable subject
    this.messageService.sendMessage(f.key);
    return false;
  }
  getSector(id) {
    return this.service.getSector(id);
  }
  deleteField(field) {
    console.log('delete:' + field.id);
    this.messageService.sendMessage('delete:' + field.id);
    return false;

  }
  showSector() {
    return environment.showSectors;
  }
}
